// extracted by mini-css-extract-plugin
export default {"lastUpdated":"styles_lastUpdated__glKNr","val":"styles_val__OX97f","container":"styles_container__IpIaK","title":"styles_title__dIfgW"};